module.exports = __webpack_public_path__ + "img/home.ec33faf2.svg";